// GENERATED from analysis/number-ones/tier2_reference.json — do not hand-edit.
// Regenerate: python3 analysis/number-ones/build_tier2_registry.py && gen_tier2_ts.py
//
// Tier II (two-letter) register evidence, reconciled across three sources:
//   PlateX sold DB (genuine sales) + DVSA vehicle/MOT history via row-data
//     -> platex-confirmed
//   UK Number Plate Registry 3plates/{a-z}.html per-plate provenance
//     -> research evidence, awaiting PlateX confirmation
// Benchmark reference with per-record provenance + confidence in the JSON —
// never public truth. Live listings override to 'available' at runtime.
// Coverage: 1157 of 1352 evidenced ({'held': 381, 'existing': 776}; confidence {'platex-confirmed': 870, 'research-evidence-awaiting-platex-confirmation': 287}).

export type Tier2RefState = 'held' | 'existing';
export const TIER2_REFERENCE: { [combo: string]: Tier2RefState } = {
  '1 AA': 'held',
  'AA 1': 'held',
  '1 AB': 'existing',
  'AB 1': 'existing',
  '1 AC': 'existing',
  'AC 1': 'existing',
  '1 AD': 'existing',
  'AD 1': 'existing',
  '1 AE': 'existing',
  'AE 1': 'held',
  '1 AF': 'existing',
  'AF 1': 'held',
  '1 AG': 'held',
  'AG 1': 'existing',
  '1 AH': 'existing',
  'AH 1': 'existing',
  '1 AI': 'existing',
  '1 AJ': 'existing',
  'AJ 1': 'existing',
  '1 AK': 'existing',
  'AK 1': 'held',
  '1 AL': 'existing',
  'AL 1': 'held',
  '1 AM': 'existing',
  'AM 1': 'existing',
  '1 AN': 'existing',
  'AN 1': 'held',
  '1 AO': 'existing',
  'AO 1': 'existing',
  '1 AP': 'existing',
  'AP 1': 'existing',
  '1 AR': 'existing',
  'AR 1': 'held',
  '1 AS': 'held',
  'AS 1': 'existing',
  '1 AT': 'held',
  'AT 1': 'held',
  '1 AU': 'existing',
  'AU 1': 'existing',
  '1 AV': 'held',
  'AV 1': 'held',
  '1 AW': 'existing',
  'AW 1': 'held',
  '1 AX': 'existing',
  'AX 1': 'held',
  '1 AY': 'existing',
  'AY 1': 'held',
  '1 AZ': 'held',
  'AZ 1': 'held',
  '1 BA': 'held',
  'BA 1': 'held',
  '1 BB': 'held',
  'BB 1': 'held',
  '1 BC': 'held',
  'BC 1': 'held',
  '1 BD': 'existing',
  'BD 1': 'existing',
  '1 BE': 'existing',
  'BE 1': 'held',
  '1 BF': 'existing',
  'BF 1': 'held',
  '1 BG': 'held',
  'BG 1': 'held',
  '1 BH': 'existing',
  'BH 1': 'existing',
  '1 BJ': 'existing',
  'BJ 1': 'existing',
  '1 BK': 'held',
  '1 BL': 'held',
  'BL 1': 'held',
  '1 BM': 'existing',
  'BM 1': 'held',
  '1 BN': 'existing',
  'BN 1': 'existing',
  '1 BO': 'existing',
  'BO 1': 'existing',
  '1 BP': 'existing',
  'BP 1': 'held',
  '1 BR': 'existing',
  'BR 1': 'existing',
  '1 BS': 'existing',
  'BS 1': 'held',
  '1 BT': 'existing',
  'BT 1': 'existing',
  '1 BU': 'existing',
  'BU 1': 'existing',
  '1 BV': 'existing',
  'BV 1': 'existing',
  '1 BW': 'existing',
  'BW 1': 'existing',
  '1 BX': 'existing',
  'BX 1': 'held',
  '1 BY': 'existing',
  'BY 1': 'existing',
  '1 BZ': 'existing',
  'BZ 1': 'existing',
  '1 CA': 'existing',
  'CA 1': 'held',
  '1 CB': 'existing',
  'CB 1': 'held',
  '1 CC': 'existing',
  'CC 1': 'existing',
  '1 CD': 'held',
  'CD 1': 'held',
  '1 CE': 'held',
  'CE 1': 'held',
  '1 CF': 'existing',
  'CF 1': 'existing',
  '1 CG': 'existing',
  'CG 1': 'existing',
  '1 CH': 'existing',
  'CH 1': 'existing',
  '1 CJ': 'existing',
  'CJ 1': 'existing',
  '1 CK': 'existing',
  'CK 1': 'existing',
  '1 CL': 'held',
  'CL 1': 'existing',
  '1 CM': 'existing',
  'CM 1': 'held',
  '1 CN': 'existing',
  'CN 1': 'held',
  '1 CO': 'held',
  'CO 1': 'existing',
  '1 CP': 'existing',
  'CP 1': 'held',
  '1 CR': 'held',
  'CR 1': 'held',
  '1 CS': 'existing',
  'CS 1': 'held',
  '1 CT': 'existing',
  'CT 1': 'held',
  '1 CU': 'existing',
  'CU 1': 'existing',
  '1 CV': 'existing',
  'CV 1': 'held',
  '1 CW': 'existing',
  'CW 1': 'held',
  '1 CX': 'existing',
  'CX 1': 'held',
  '1 CY': 'existing',
  'CY 1': 'existing',
  '1 CZ': 'held',
  'CZ 1': 'held',
  '1 DA': 'existing',
  'DA 1': 'existing',
  '1 DB': 'held',
  'DB 1': 'held',
  '1 DC': 'existing',
  'DC 1': 'held',
  '1 DD': 'existing',
  'DD 1': 'held',
  '1 DE': 'held',
  'DE 1': 'existing',
  '1 DF': 'existing',
  'DF 1': 'existing',
  '1 DG': 'existing',
  'DG 1': 'existing',
  '1 DH': 'held',
  'DH 1': 'held',
  '1 DJ': 'existing',
  'DJ 1': 'held',
  '1 DK': 'existing',
  'DK 1': 'held',
  '1 DL': 'existing',
  'DL 1': 'existing',
  '1 DM': 'held',
  'DM 1': 'held',
  '1 DN': 'existing',
  'DN 1': 'held',
  '1 DO': 'existing',
  'DO 1': 'held',
  '1 DP': 'existing',
  'DP 1': 'existing',
  '1 DR': 'existing',
  'DR 1': 'existing',
  '1 DS': 'existing',
  'DS 1': 'existing',
  '1 DT': 'existing',
  'DT 1': 'existing',
  '1 DU': 'existing',
  'DU 1': 'existing',
  '1 DV': 'existing',
  'DV 1': 'held',
  '1 DW': 'existing',
  'DW 1': 'existing',
  '1 DX': 'existing',
  'DX 1': 'existing',
  '1 DY': 'existing',
  'DY 1': 'existing',
  '1 DZ': 'existing',
  'DZ 1': 'existing',
  '1 EA': 'held',
  'EA 1': 'held',
  '1 EB': 'existing',
  'EB 1': 'existing',
  '1 EC': 'held',
  'EC 1': 'existing',
  '1 ED': 'existing',
  'ED 1': 'held',
  '1 EE': 'existing',
  'EE 1': 'held',
  '1 EF': 'held',
  'EF 1': 'held',
  '1 EG': 'existing',
  'EG 1': 'held',
  '1 EH': 'existing',
  'EH 1': 'held',
  '1 EJ': 'held',
  'EJ 1': 'held',
  '1 EK': 'existing',
  'EK 1': 'held',
  '1 EL': 'existing',
  'EL 1': 'held',
  '1 EM': 'existing',
  'EM 1': 'held',
  '1 EN': 'held',
  'EN 1': 'held',
  '1 EO': 'held',
  'EO 1': 'existing',
  '1 EP': 'existing',
  'EP 1': 'held',
  '1 ER': 'existing',
  'ER 1': 'held',
  '1 ES': 'held',
  'ES 1': 'held',
  '1 ET': 'existing',
  'ET 1': 'held',
  '1 EU': 'existing',
  'EU 1': 'existing',
  '1 EV': 'existing',
  'EV 1': 'held',
  '1 EW': 'existing',
  'EW 1': 'existing',
  '1 EX': 'existing',
  'EX 1': 'held',
  '1 EY': 'existing',
  'EY 1': 'held',
  '1 EZ': 'existing',
  'EZ 1': 'held',
  '1 FA': 'existing',
  'FA 1': 'held',
  '1 FB': 'existing',
  'FB 1': 'existing',
  '1 FC': 'existing',
  'FC 1': 'held',
  '1 FD': 'held',
  'FD 1': 'held',
  '1 FE': 'existing',
  'FE 1': 'held',
  '1 FF': 'existing',
  'FF 1': 'held',
  '1 FG': 'existing',
  'FG 1': 'held',
  '1 FH': 'existing',
  'FH 1': 'held',
  '1 FJ': 'existing',
  'FJ 1': 'existing',
  '1 FK': 'existing',
  'FK 1': 'existing',
  '1 FL': 'held',
  'FL 1': 'existing',
  '1 FM': 'existing',
  'FM 1': 'held',
  '1 FN': 'existing',
  'FN 1': 'existing',
  '1 FO': 'existing',
  'FO 1': 'existing',
  '1 FP': 'existing',
  'FP 1': 'existing',
  '1 FR': 'existing',
  'FR 1': 'held',
  '1 FS': 'held',
  'FS 1': 'existing',
  '1 FT': 'existing',
  'FT 1': 'existing',
  '1 FU': 'existing',
  'FU 1': 'existing',
  '1 FV': 'existing',
  'FV 1': 'existing',
  '1 FW': 'existing',
  'FW 1': 'held',
  '1 FX': 'existing',
  'FX 1': 'held',
  '1 FY': 'existing',
  'FY 1': 'held',
  '1 FZ': 'existing',
  'FZ 1': 'existing',
  '1 GA': 'existing',
  'GA 1': 'existing',
  '1 GB': 'existing',
  'GB 1': 'existing',
  '1 GC': 'existing',
  'GC 1': 'held',
  '1 GD': 'existing',
  'GD 1': 'held',
  '1 GE': 'existing',
  'GE 1': 'existing',
  '1 GF': 'held',
  'GF 1': 'existing',
  '1 GG': 'existing',
  'GG 1': 'held',
  '1 GH': 'existing',
  'GH 1': 'held',
  '1 GJ': 'existing',
  'GJ 1': 'existing',
  '1 GK': 'held',
  'GK 1': 'held',
  '1 GL': 'existing',
  'GL 1': 'existing',
  '1 GM': 'existing',
  'GM 1': 'held',
  '1 GN': 'held',
  'GN 1': 'existing',
  '1 GO': 'existing',
  'GO 1': 'existing',
  '1 GP': 'existing',
  'GP 1': 'existing',
  '1 GR': 'existing',
  'GR 1': 'held',
  '1 GS': 'existing',
  'GS 1': 'held',
  '1 GT': 'existing',
  'GT 1': 'existing',
  '1 GU': 'existing',
  'GU 1': 'held',
  '1 GV': 'existing',
  'GV 1': 'existing',
  '1 GW': 'existing',
  'GW 1': 'existing',
  '1 GX': 'held',
  'GX 1': 'existing',
  '1 GY': 'existing',
  'GY 1': 'held',
  '1 GZ': 'existing',
  'GZ 1': 'existing',
  '1 HA': 'held',
  'HA 1': 'existing',
  '1 HB': 'held',
  'HB 1': 'held',
  '1 HC': 'existing',
  'HC 1': 'existing',
  '1 HD': 'existing',
  'HD 1': 'existing',
  '1 HE': 'existing',
  'HE 1': 'existing',
  '1 HF': 'existing',
  'HF 1': 'existing',
  '1 HG': 'existing',
  'HG 1': 'held',
  '1 HH': 'existing',
  'HH 1': 'existing',
  '1 HJ': 'existing',
  'HJ 1': 'held',
  '1 HK': 'held',
  'HK 1': 'held',
  '1 HL': 'existing',
  'HL 1': 'existing',
  '1 HM': 'existing',
  'HM 1': 'existing',
  '1 HN': 'existing',
  'HN 1': 'held',
  '1 HO': 'existing',
  'HO 1': 'existing',
  '1 HP': 'held',
  'HP 1': 'existing',
  '1 HR': 'existing',
  'HR 1': 'held',
  '1 HS': 'held',
  'HS 1': 'existing',
  '1 HT': 'existing',
  'HT 1': 'existing',
  '1 HU': 'existing',
  'HU 1': 'existing',
  '1 HV': 'existing',
  'HV 1': 'existing',
  '1 HW': 'existing',
  'HW 1': 'held',
  '1 HX': 'held',
  'HX 1': 'existing',
  '1 HY': 'existing',
  'HY 1': 'existing',
  '1 HZ': 'existing',
  'HZ 1': 'existing',
  '1 IA': 'existing',
  'IA 1': 'existing',
  '1 IB': 'existing',
  'IB 1': 'held',
  '1 IC': 'existing',
  'IC 1': 'held',
  '1 ID': 'existing',
  'ID 1': 'existing',
  '1 IE': 'existing',
  'IE 1': 'existing',
  '1 IF': 'existing',
  'IF 1': 'existing',
  '1 IG': 'existing',
  'IG 1': 'existing',
  '1 IH': 'existing',
  '1 II': 'existing',
  'II 1': 'existing',
  '1 IJ': 'existing',
  'IJ 1': 'existing',
  '1 IK': 'existing',
  'IK 1': 'existing',
  '1 IL': 'existing',
  'IL 1': 'existing',
  '1 IM': 'existing',
  'IM 1': 'existing',
  '1 IN': 'existing',
  'IN 1': 'existing',
  '1 IO': 'existing',
  'IO 1': 'existing',
  '1 IP': 'existing',
  'IP 1': 'existing',
  '1 IR': 'existing',
  'IR 1': 'existing',
  '1 IS': 'existing',
  'IS 1': 'existing',
  '1 IT': 'existing',
  'IT 1': 'existing',
  '1 IU': 'existing',
  'IU 1': 'existing',
  '1 IV': 'existing',
  'IV 1': 'existing',
  '1 IW': 'existing',
  'IW 1': 'existing',
  '1 IX': 'existing',
  'IX 1': 'existing',
  '1 IY': 'existing',
  'IY 1': 'held',
  '1 IZ': 'existing',
  'IZ 1': 'existing',
  '1 JA': 'existing',
  'JA 1': 'existing',
  '1 JB': 'existing',
  'JB 1': 'held',
  '1 JC': 'held',
  'JC 1': 'held',
  '1 JD': 'held',
  'JD 1': 'held',
  '1 JE': 'existing',
  'JE 1': 'existing',
  '1 JF': 'held',
  'JF 1': 'held',
  '1 JG': 'existing',
  'JG 1': 'existing',
  '1 JH': 'existing',
  'JH 1': 'existing',
  '1 JJ': 'existing',
  'JJ 1': 'held',
  '1 JK': 'existing',
  'JK 1': 'existing',
  '1 JL': 'existing',
  'JL 1': 'existing',
  '1 JM': 'held',
  'JM 1': 'held',
  '1 JN': 'existing',
  'JN 1': 'existing',
  '1 JO': 'existing',
  'JO 1': 'held',
  '1 JP': 'existing',
  'JP 1': 'existing',
  '1 JR': 'existing',
  'JR 1': 'held',
  '1 JS': 'held',
  'JS 1': 'held',
  '1 JT': 'held',
  'JT 1': 'existing',
  '1 JU': 'existing',
  'JU 1': 'existing',
  '1 JV': 'existing',
  'JV 1': 'held',
  '1 JW': 'held',
  'JW 1': 'held',
  '1 JX': 'existing',
  'JX 1': 'existing',
  '1 JY': 'existing',
  'JY 1': 'existing',
  '1 JZ': 'existing',
  'JZ 1': 'held',
  '1 KA': 'existing',
  'KA 1': 'held',
  '1 KB': 'existing',
  'KB 1': 'existing',
  '1 KC': 'held',
  'KC 1': 'existing',
  '1 KD': 'held',
  'KD 1': 'existing',
  '1 KE': 'existing',
  'KE 1': 'existing',
  '1 KF': 'existing',
  'KF 1': 'held',
  '1 KG': 'existing',
  'KG 1': 'held',
  '1 KH': 'held',
  'KH 1': 'held',
  'KI 1': 'existing',
  '1 KJ': 'existing',
  'KJ 1': 'existing',
  '1 KK': 'existing',
  'KK 1': 'existing',
  '1 KL': 'existing',
  'KL 1': 'held',
  '1 KM': 'held',
  'KM 1': 'held',
  '1 KN': 'existing',
  'KN 1': 'existing',
  '1 KO': 'held',
  'KO 1': 'existing',
  '1 KP': 'existing',
  'KP 1': 'existing',
  '1 KR': 'held',
  'KR 1': 'existing',
  '1 KS': 'existing',
  'KS 1': 'existing',
  '1 KT': 'existing',
  'KT 1': 'existing',
  '1 KU': 'existing',
  'KU 1': 'existing',
  '1 KV': 'existing',
  'KV 1': 'held',
  '1 KW': 'existing',
  'KW 1': 'existing',
  '1 KX': 'held',
  'KX 1': 'existing',
  '1 KY': 'held',
  'KY 1': 'existing',
  '1 KZ': 'held',
  'KZ 1': 'existing',
  '1 LA': 'existing',
  'LA 1': 'held',
  '1 LB': 'existing',
  'LB 1': 'existing',
  '1 LC': 'existing',
  'LC 1': 'existing',
  '1 LD': 'existing',
  'LD 1': 'held',
  '1 LE': 'existing',
  'LE 1': 'existing',
  '1 LF': 'existing',
  'LF 1': 'existing',
  '1 LG': 'existing',
  'LG 1': 'existing',
  '1 LH': 'existing',
  'LH 1': 'held',
  '1 LJ': 'existing',
  'LJ 1': 'existing',
  '1 LK': 'existing',
  'LK 1': 'existing',
  '1 LL': 'held',
  'LL 1': 'existing',
  '1 LM': 'existing',
  'LM 1': 'existing',
  '1 LN': 'existing',
  'LN 1': 'existing',
  '1 LO': 'existing',
  'LO 1': 'existing',
  '1 LP': 'existing',
  'LP 1': 'held',
  '1 LR': 'existing',
  'LR 1': 'held',
  '1 LS': 'existing',
  'LS 1': 'held',
  '1 LT': 'held',
  'LT 1': 'existing',
  '1 LU': 'existing',
  'LU 1': 'existing',
  '1 LV': 'existing',
  'LV 1': 'existing',
  '1 LW': 'existing',
  'LW 1': 'held',
  '1 LX': 'existing',
  'LX 1': 'existing',
  '1 LY': 'existing',
  'LY 1': 'existing',
  '1 LZ': 'held',
  'LZ 1': 'existing',
  '1 MA': 'existing',
  'MA 1': 'existing',
  '1 MB': 'existing',
  'MB 1': 'existing',
  '1 MC': 'existing',
  'MC 1': 'existing',
  '1 MD': 'existing',
  'MD 1': 'existing',
  '1 ME': 'held',
  'ME 1': 'existing',
  '1 MF': 'existing',
  'MF 1': 'held',
  '1 MG': 'existing',
  'MG 1': 'held',
  '1 MH': 'existing',
  'MH 1': 'existing',
  'MI 1': 'existing',
  '1 MJ': 'existing',
  'MJ 1': 'existing',
  '1 MK': 'existing',
  'MK 1': 'held',
  '1 ML': 'held',
  'ML 1': 'held',
  '1 MM': 'held',
  'MM 1': 'existing',
  '1 MO': 'existing',
  'MO 1': 'held',
  '1 MP': 'existing',
  'MP 1': 'held',
  '1 MR': 'held',
  'MR 1': 'existing',
  '1 MS': 'held',
  'MS 1': 'existing',
  '1 MT': 'held',
  'MT 1': 'held',
  '1 MU': 'existing',
  'MU 1': 'existing',
  '1 MV': 'held',
  'MV 1': 'existing',
  '1 MW': 'held',
  'MW 1': 'held',
  '1 MX': 'existing',
  'MX 1': 'existing',
  '1 MY': 'existing',
  'MY 1': 'held',
  '1 MZ': 'held',
  'MZ 1': 'existing',
  '1 NA': 'existing',
  'NA 1': 'held',
  '1 NB': 'existing',
  'NB 1': 'held',
  '1 NC': 'existing',
  'NC 1': 'existing',
  '1 ND': 'held',
  'ND 1': 'existing',
  '1 NE': 'held',
  'NE 1': 'existing',
  '1 NF': 'existing',
  'NF 1': 'existing',
  '1 NG': 'held',
  'NG 1': 'existing',
  '1 NH': 'existing',
  'NH 1': 'held',
  '1 NJ': 'existing',
  'NJ 1': 'held',
  '1 NK': 'existing',
  'NK 1': 'existing',
  '1 NL': 'existing',
  'NL 1': 'existing',
  '1 NM': 'existing',
  'NM 1': 'held',
  '1 NN': 'existing',
  'NN 1': 'existing',
  '1 NO': 'existing',
  'NO 1': 'existing',
  '1 NP': 'existing',
  'NP 1': 'existing',
  '1 NR': 'held',
  'NR 1': 'existing',
  '1 NS': 'existing',
  'NS 1': 'existing',
  '1 NT': 'held',
  'NT 1': 'held',
  '1 NU': 'existing',
  'NU 1': 'existing',
  '1 NV': 'existing',
  'NV 1': 'existing',
  '1 NW': 'existing',
  'NW 1': 'existing',
  '1 NX': 'existing',
  'NX 1': 'existing',
  '1 NY': 'existing',
  'NY 1': 'existing',
  '1 NZ': 'held',
  'NZ 1': 'held',
  '1 OA': 'existing',
  'OA 1': 'held',
  '1 OB': 'existing',
  'OB 1': 'existing',
  '1 OC': 'existing',
  'OC 1': 'held',
  '1 OD': 'existing',
  'OD 1': 'existing',
  '1 OE': 'held',
  'OE 1': 'existing',
  '1 OF': 'existing',
  'OF 1': 'existing',
  '1 OG': 'existing',
  'OG 1': 'existing',
  '1 OH': 'existing',
  'OH 1': 'existing',
  'OI 1': 'existing',
  '1 OJ': 'existing',
  'OJ 1': 'held',
  '1 OK': 'existing',
  'OK 1': 'held',
  '1 OL': 'existing',
  'OL 1': 'existing',
  '1 OM': 'existing',
  'OM 1': 'existing',
  '1 ON': 'existing',
  'ON 1': 'existing',
  '1 OO': 'existing',
  'OO 1': 'existing',
  '1 OP': 'existing',
  'OP 1': 'existing',
  '1 OR': 'held',
  'OR 1': 'existing',
  '1 OS': 'existing',
  'OS 1': 'held',
  '1 OT': 'existing',
  'OT 1': 'held',
  '1 OU': 'existing',
  'OU 1': 'held',
  '1 OV': 'existing',
  'OV 1': 'existing',
  '1 OW': 'existing',
  'OW 1': 'held',
  '1 OX': 'existing',
  'OX 1': 'existing',
  '1 OY': 'held',
  'OY 1': 'existing',
  '1 OZ': 'existing',
  'OZ 1': 'existing',
  '1 PA': 'existing',
  'PA 1': 'existing',
  '1 PB': 'existing',
  'PB 1': 'held',
  '1 PC': 'existing',
  'PC 1': 'held',
  '1 PD': 'existing',
  'PD 1': 'held',
  '1 PE': 'existing',
  'PE 1': 'existing',
  '1 PF': 'held',
  'PF 1': 'existing',
  '1 PG': 'held',
  'PG 1': 'existing',
  '1 PH': 'held',
  'PH 1': 'existing',
  '1 PJ': 'held',
  'PJ 1': 'held',
  '1 PK': 'held',
  'PK 1': 'existing',
  '1 PL': 'held',
  'PL 1': 'existing',
  '1 PM': 'held',
  'PM 1': 'held',
  '1 PN': 'existing',
  'PN 1': 'existing',
  '1 PO': 'existing',
  'PO 1': 'existing',
  '1 PP': 'existing',
  'PP 1': 'existing',
  '1 PR': 'existing',
  'PR 1': 'existing',
  '1 PS': 'held',
  'PS 1': 'held',
  '1 PT': 'existing',
  'PT 1': 'existing',
  '1 PU': 'existing',
  'PU 1': 'existing',
  '1 PV': 'existing',
  'PV 1': 'held',
  '1 PW': 'existing',
  'PW 1': 'existing',
  '1 PX': 'held',
  'PX 1': 'held',
  '1 PY': 'existing',
  'PY 1': 'existing',
  '1 PZ': 'existing',
  'PZ 1': 'existing',
  'QK 1': 'existing',
  '1 RA': 'existing',
  'RA 1': 'existing',
  '1 RB': 'held',
  'RB 1': 'held',
  '1 RC': 'existing',
  'RC 1': 'existing',
  '1 RD': 'existing',
  'RD 1': 'held',
  '1 RE': 'held',
  'RE 1': 'held',
  '1 RF': 'existing',
  'RF 1': 'existing',
  '1 RG': 'existing',
  'RG 1': 'held',
  '1 RH': 'existing',
  'RH 1': 'existing',
  'RI 1': 'held',
  '1 RJ': 'existing',
  'RJ 1': 'held',
  '1 RK': 'existing',
  'RK 1': 'existing',
  '1 RL': 'held',
  'RL 1': 'existing',
  '1 RM': 'held',
  'RM 1': 'existing',
  '1 RN': 'held',
  'RN 1': 'existing',
  '1 RO': 'existing',
  'RO 1': 'held',
  '1 RP': 'existing',
  'RP 1': 'existing',
  '1 RR': 'existing',
  'RR 1': 'existing',
  '1 RS': 'held',
  'RS 1': 'existing',
  '1 RT': 'existing',
  'RT 1': 'existing',
  '1 RU': 'held',
  'RU 1': 'held',
  '1 RV': 'existing',
  'RV 1': 'held',
  '1 RW': 'existing',
  'RW 1': 'existing',
  '1 RX': 'existing',
  'RX 1': 'existing',
  '1 RY': 'existing',
  'RY 1': 'held',
  '1 RZ': 'existing',
  'RZ 1': 'held',
  '1 SA': 'held',
  'SA 1': 'held',
  '1 SB': 'existing',
  'SB 1': 'held',
  '1 SC': 'existing',
  'SC 1': 'held',
  '1 SD': 'existing',
  'SD 1': 'held',
  '1 SE': 'held',
  'SE 1': 'existing',
  '1 SF': 'held',
  'SF 1': 'held',
  '1 SG': 'held',
  'SG 1': 'existing',
  '1 SH': 'existing',
  'SH 1': 'held',
  '1 SJ': 'existing',
  'SJ 1': 'held',
  '1 SK': 'held',
  'SK 1': 'held',
  '1 SL': 'existing',
  'SL 1': 'existing',
  '1 SM': 'existing',
  'SM 1': 'existing',
  '1 SN': 'existing',
  'SN 1': 'held',
  '1 SO': 'existing',
  'SO 1': 'existing',
  '1 SP': 'existing',
  'SP 1': 'held',
  '1 SR': 'existing',
  'SR 1': 'held',
  '1 SS': 'existing',
  'SS 1': 'held',
  '1 ST': 'existing',
  'ST 1': 'existing',
  '1 SU': 'existing',
  'SU 1': 'existing',
  '1 SV': 'existing',
  'SV 1': 'existing',
  '1 SW': 'existing',
  'SW 1': 'existing',
  '1 SX': 'held',
  'SX 1': 'held',
  '1 SY': 'existing',
  'SY 1': 'held',
  '1 SZ': 'existing',
  'SZ 1': 'existing',
  '1 TA': 'held',
  'TA 1': 'existing',
  '1 TB': 'existing',
  'TB 1': 'held',
  '1 TC': 'held',
  'TC 1': 'existing',
  '1 TD': 'existing',
  'TD 1': 'existing',
  '1 TE': 'held',
  'TE 1': 'held',
  '1 TF': 'existing',
  'TF 1': 'held',
  '1 TG': 'existing',
  'TG 1': 'existing',
  '1 TH': 'held',
  'TH 1': 'held',
  '1 TJ': 'existing',
  'TJ 1': 'existing',
  '1 TK': 'held',
  'TK 1': 'existing',
  '1 TL': 'existing',
  'TL 1': 'existing',
  '1 TM': 'held',
  'TM 1': 'held',
  '1 TN': 'existing',
  'TN 1': 'existing',
  '1 TO': 'existing',
  'TO 1': 'held',
  '1 TP': 'held',
  'TP 1': 'held',
  '1 TR': 'existing',
  'TR 1': 'held',
  '1 TS': 'existing',
  'TS 1': 'existing',
  '1 TT': 'existing',
  'TT 1': 'held',
  '1 TU': 'held',
  'TU 1': 'existing',
  '1 TV': 'existing',
  'TV 1': 'existing',
  '1 TW': 'existing',
  'TW 1': 'existing',
  '1 TX': 'held',
  'TX 1': 'existing',
  '1 TY': 'existing',
  'TY 1': 'held',
  '1 TZ': 'held',
  'TZ 1': 'held',
  '1 UA': 'existing',
  'UA 1': 'held',
  '1 UB': 'held',
  'UB 1': 'held',
  '1 UC': 'existing',
  'UC 1': 'existing',
  '1 UD': 'held',
  'UD 1': 'existing',
  '1 UE': 'existing',
  'UE 1': 'existing',
  '1 UF': 'existing',
  'UF 1': 'existing',
  '1 UG': 'held',
  'UG 1': 'existing',
  '1 UH': 'existing',
  'UH 1': 'existing',
  '1 UJ': 'existing',
  'UJ 1': 'existing',
  '1 UK': 'existing',
  'UK 1': 'held',
  '1 UL': 'existing',
  'UL 1': 'existing',
  '1 UM': 'held',
  'UM 1': 'existing',
  '1 UN': 'existing',
  'UN 1': 'held',
  '1 UO': 'existing',
  'UO 1': 'existing',
  '1 UP': 'existing',
  'UP 1': 'existing',
  '1 UR': 'held',
  'UR 1': 'existing',
  '1 US': 'existing',
  'US 1': 'held',
  '1 UT': 'existing',
  'UT 1': 'existing',
  '1 UU': 'existing',
  'UU 1': 'existing',
  '1 UV': 'existing',
  'UV 1': 'existing',
  '1 UW': 'existing',
  'UW 1': 'existing',
  '1 UX': 'held',
  'UX 1': 'held',
  '1 UY': 'existing',
  'UY 1': 'existing',
  '1 UZ': 'existing',
  'UZ 1': 'held',
  '1 VA': 'existing',
  'VA 1': 'held',
  '1 VB': 'existing',
  'VB 1': 'existing',
  '1 VC': 'held',
  'VC 1': 'held',
  '1 VD': 'existing',
  'VD 1': 'existing',
  '1 VE': 'held',
  'VE 1': 'existing',
  '1 VF': 'existing',
  'VF 1': 'held',
  '1 VG': 'existing',
  'VG 1': 'held',
  '1 VH': 'held',
  'VH 1': 'held',
  '1 VJ': 'existing',
  'VJ 1': 'held',
  '1 VK': 'held',
  'VK 1': 'existing',
  '1 VL': 'existing',
  'VL 1': 'held',
  '1 VM': 'existing',
  'VM 1': 'held',
  '1 VN': 'existing',
  'VN 1': 'held',
  '1 VO': 'existing',
  'VO 1': 'existing',
  '1 VP': 'held',
  'VP 1': 'held',
  '1 VR': 'existing',
  'VR 1': 'held',
  '1 VS': 'existing',
  'VS 1': 'existing',
  '1 VT': 'held',
  'VT 1': 'held',
  '1 VU': 'held',
  'VU 1': 'existing',
  '1 VV': 'existing',
  'VV 1': 'held',
  '1 VW': 'existing',
  'VW 1': 'existing',
  '1 VX': 'existing',
  'VX 1': 'existing',
  '1 VY': 'held',
  'VY 1': 'held',
  '1 VZ': 'existing',
  'VZ 1': 'held',
  '1 WA': 'existing',
  'WA 1': 'held',
  '1 WB': 'existing',
  'WB 1': 'existing',
  '1 WC': 'existing',
  'WC 1': 'existing',
  '1 WD': 'existing',
  'WD 1': 'held',
  '1 WE': 'existing',
  'WE 1': 'held',
  '1 WF': 'existing',
  'WF 1': 'held',
  '1 WG': 'held',
  'WG 1': 'held',
  '1 WH': 'existing',
  'WH 1': 'held',
  '1 WJ': 'existing',
  'WJ 1': 'existing',
  '1 WK': 'existing',
  'WK 1': 'held',
  '1 WL': 'existing',
  'WL 1': 'existing',
  '1 WM': 'existing',
  'WM 1': 'held',
  '1 WN': 'existing',
  'WN 1': 'existing',
  '1 WO': 'held',
  'WO 1': 'existing',
  '1 WP': 'existing',
  'WP 1': 'held',
  '1 WR': 'existing',
  'WR 1': 'existing',
  '1 WS': 'held',
  'WS 1': 'held',
  '1 WT': 'existing',
  'WT 1': 'held',
  '1 WU': 'held',
  'WU 1': 'existing',
  '1 WV': 'existing',
  'WV 1': 'existing',
  '1 WW': 'held',
  'WW 1': 'existing',
  '1 WX': 'held',
  'WX 1': 'existing',
  '1 WY': 'existing',
  'WY 1': 'existing',
  '1 WZ': 'held',
  'WZ 1': 'existing',
  '1 XA': 'held',
  'XA 1': 'existing',
  '1 XB': 'existing',
  'XB 1': 'existing',
  '1 XC': 'existing',
  'XC 1': 'existing',
  '1 XD': 'existing',
  'XD 1': 'existing',
  '1 XE': 'existing',
  'XE 1': 'held',
  '1 XF': 'existing',
  'XF 1': 'existing',
  '1 XG': 'existing',
  'XG 1': 'held',
  '1 XH': 'existing',
  'XH 1': 'existing',
  '1 XJ': 'existing',
  'XJ 1': 'existing',
  '1 XK': 'existing',
  'XK 1': 'existing',
  '1 XL': 'held',
  'XL 1': 'existing',
  '1 XM': 'existing',
  'XM 1': 'existing',
  '1 XN': 'existing',
  'XN 1': 'existing',
  '1 XO': 'existing',
  'XO 1': 'existing',
  '1 XP': 'existing',
  'XP 1': 'held',
  '1 XR': 'existing',
  'XR 1': 'existing',
  '1 XS': 'existing',
  'XS 1': 'held',
  '1 XT': 'existing',
  'XT 1': 'existing',
  '1 XU': 'existing',
  'XU 1': 'existing',
  '1 XV': 'existing',
  'XV 1': 'existing',
  '1 XW': 'existing',
  'XW 1': 'existing',
  '1 XX': 'existing',
  'XX 1': 'held',
  '1 XY': 'existing',
  'XY 1': 'existing',
  '1 XZ': 'existing',
  'XZ 1': 'existing',
  '1 YA': 'existing',
  'YA 1': 'existing',
  '1 YB': 'existing',
  'YB 1': 'existing',
  '1 YC': 'existing',
  'YC 1': 'existing',
  '1 YD': 'existing',
  'YD 1': 'existing',
  '1 YE': 'held',
  'YE 1': 'existing',
  '1 YF': 'held',
  'YF 1': 'held',
  '1 YG': 'held',
  'YG 1': 'existing',
  '1 YH': 'existing',
  'YH 1': 'existing',
  '1 YJ': 'held',
  'YJ 1': 'existing',
  '1 YK': 'existing',
  'YK 1': 'existing',
  '1 YL': 'existing',
  'YL 1': 'existing',
  '1 YM': 'existing',
  'YM 1': 'existing',
  '1 YN': 'held',
  'YN 1': 'held',
  '1 YO': 'existing',
  'YO 1': 'held',
  '1 YP': 'existing',
  'YP 1': 'existing',
  '1 YR': 'existing',
  'YR 1': 'held',
  '1 YS': 'held',
  'YS 1': 'held',
  '1 YT': 'existing',
  'YT 1': 'held',
  '1 YU': 'existing',
  'YU 1': 'held',
  '1 YV': 'existing',
  'YV 1': 'existing',
  '1 YW': 'existing',
  'YW 1': 'existing',
  '1 YX': 'existing',
  'YX 1': 'existing',
  '1 YY': 'existing',
  'YY 1': 'held',
  '1 YZ': 'held',
  'YZ 1': 'existing',
  'ZY 1': 'held',
};
